import { render, staticRenderFns } from "./UserManageDetail.vue?vue&type=template&id=398d278c"
import script from "./UserManageDetail.vue?vue&type=script&lang=js"
export * from "./UserManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports